// Menu.js
import { Dashboard, Euro, Group, LibraryBooks, PermContactCalendar, Restaurant, Settings } from "@material-ui/icons";
import { getTranslation } from "../../heplers/translationHelper";
import authService from "../../utils/authUtils";




export const getNavConfig = (role) => {
  const adminMenu=[
    {
      title: getTranslation("Restaurants", "Restaurants", "Restaurants"),
      icon: Restaurant,
      href: "/admin/restaurants",
    },
    // {
    //   title: getTranslation("Settings", "Settings", "Settings"),
    //   icon: Settings,
    //   href: "/admin/settings/table-management/:tab",
    // },
    
  ]
  const customerMenu=[
    {
      title: getTranslation("Dashboard", "Dashboard", "Dashboard"),
      icon: Dashboard,
      href: "/customer/dashboard",
    },
    {
      title: getTranslation("Reservations", "Reservations", "Reservations"),
      icon: LibraryBooks,
      href: "/customer/reservations",

 
    },
    {
      title: getTranslation("Z Cash", "Z Cash", "Z Cash"),
      icon: Euro,
      href: "/customer/zcash",
    },
    {
      title: getTranslation("Customers", "Customers", "Customers"),
      icon: PermContactCalendar,
      href: "/customer/customers",
    },
    // {
    //   title: getTranslation("Restaurants", "Restaurants", "Restaurants"),
    //   icon: Restaurant,
    //   href: "/customer/restaurants",
    // },
    // {
    //   title: getTranslation("Customer", "Visit", "Visit"),
    //   icon: Group,
    //   href: "/customer/customer",
    // },
    {
      title: getTranslation("Users", "Users", "Users"),
      icon: PermContactCalendar,
      href: "/customer/users/list",
    },
    {
      title: getTranslation("Settings", "Settings", "Settings"),
      icon: Settings,
      href: "/customer/settings",
    },
  ]
  const managerMenu=[
    {
      title: getTranslation("Dashboard", "Dashboard", "Dashboard"),
      icon: Dashboard,
      href: "/manager/dashboard",
    },
    // {
    //   title: getTranslation("Reservations", "Reservations", "Reservations"),
    //   icon: LibraryBooks,
    //   href: "/manager/reservations",
    // },
    {
      title: getTranslation("Z Cash", "Z Cash", "Z Cash"),
      icon: Euro,
      href: "/manager/zcash",
    },

    {
      title: getTranslation("Users", "Users", "Users"),
      icon: PermContactCalendar,
      href: "/manager/users/list",
    },
    {
      title: getTranslation("Customers", "Customers", "Customers"),
      icon: PermContactCalendar,
      href: "/manager/customers",
    },
    {
      title: getTranslation("Settings", "Settings", "Settings"),
      icon: Settings,
      href: "/manager/settings",
    },
  ]

  const zcashMenu=[
    {
      title: getTranslation("Dashboard", "Dashboard", "Dashboard"),
      icon: Dashboard,
      href: "/zcash/dashboard",
    },
    {
      title: getTranslation("Customers", "Customers", "Customers"),
      icon: PermContactCalendar,
      href: "/zcash/customers",
    },
    {
      title: getTranslation("Z Cash", "Z Cash", "Z Cash"),
      icon: Euro,
      href: "/zcash",
    },
  ]

  const staffMenu=[
    {
      title: getTranslation("Dashboard", "Dashboard", "Dashboard"),
      icon: Dashboard,
      href: "/staff/dashboard",
    },
    {
      title: getTranslation("Customers", "Customers", "Customers"),
      icon: PermContactCalendar,
      href: "/staff/customers",
    },
    {
      title: getTranslation("Reservations", "Reservations", "Reservations"),
      icon: LibraryBooks,
      href: "/staff/reservations",

 
    },
  ]
 
  if(role=="Admin")
    return [
      {
        subheader: "",
        items: adminMenu,
      },
    ];
  if(role=="Customer")
    return [
      {
        subheader: "",
        items: customerMenu,
      },
    ];
  if(role=="Manager")
    return [
      {
        subheader: "",
        items: managerMenu,
      },
    ];
  if(role=="Staff")
    return [
      {
        subheader: "",
        items: staffMenu,
      },
    ];
  if(role=="ZCash")
    return [
      {
        subheader: "",
        items: zcashMenu,
      },
    ];

  // Filter items based on role
  return [
    {
      subheader: "",
      items: [],
    },
  ];
};


export default getNavConfig;